import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-service-unavailable',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="unavailable-container">
      <div class="unavailable-wrapper">
        <mat-icon class="unavailable-icon">build</mat-icon>
        <h2 class="title">Servicio temporalmente en mantenimiento</h2>
        <p class="subtitle">
          Estamos realizando mejoras para brindarte una mejor experiencia.
        </p>
      </div>
    </div>
  `,
  styles: [
    `
      .unavailable-container {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        padding: 20px;
        box-sizing: border-box;
      }
      .unavailable-wrapper {
        text-align: center;
        max-width: 360px;
      }
      .unavailable-icon {
        font-size: 72px;
        width: 72px;
        height: 72px;
        color: #f0a500;
        margin-bottom: 12px;
      }
      .title {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 600;
        color: #444;
      }
      .subtitle {
        margin: 0;
        font-size: 14px;
        color: #666;
      }
    `,
  ],
})
export class ServiceUnavailableComponent {}
